module.exports = __webpack_public_path__ + "img/yyhb-img1-4.00c13af7.png";